/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartVaccinesDetailAliases {
  BUTTON_DOWNLOAD = 'button-download',
  BUTTON_EMAIL = 'button-email',
  CONTEXTUAL_BAR_VACCINE_DETAIL = 'contextual-bar-vaccine-detail',
  FIELD_ADVERSE_REACTION = 'field-adverse-reaction',
  FIELD_APPLICATION_DATE = 'field-application-date',
  FIELD_DOSE = 'field-dose',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_ESTIMED_DATE = 'field-estimed-date',
  FIELD_NEXT_DOSE_DATE = 'field-next-dose-date',
  FIELD_NOTES = 'field-notes',
  FIELD_STATUS = 'field-status',
  FIELD_VACCINE_NAME = 'field-vaccine-name',
  FORM_VACCINE = 'form-vaccine',
  INPUT_APPLICATION_DATE = 'input-application-date',
  INPUT_ESTIMED_DATE = 'input-estimed-date',
  INPUT_NEXT_DOSE = 'input-next-dose',
  INPUT_VACCINES_FORMULARY_DOSE_MY_CHART_VACCINES_DETAIL = 'input-vaccines-formulary-dose-my-chart-vaccines-detail',
  INPUT_VACCINES_FORMULARY_STATUS_MY_CHART_VACCINES_DETAIL = 'input-vaccines-formulary-status-my-chart-vaccines-detail',
  LAYOUT_VACCINE_DETAIL = 'layout-vaccine-detail',
  PANEL_VACCINE = 'panel-vaccine',
  TEXT_VACCINES_FORMULARY_ADVERSE_REACTION_MY_CHART_VACCINES_DETAIL = 'text-vaccines-formulary-adverse-reaction-my-chart-vaccines-detail',
  TEXT_VACCINES_FORMULARY_ESTABLISHMENT_MY_CHART_VACCINES_DETAIL = 'text-vaccines-formulary-establishment-my-chart-vaccines-detail',
  TEXT_VACCINES_FORMULARY_NOTES_MY_CHART_VACCINES_DETAIL = 'text-vaccines-formulary-notes-my-chart-vaccines-detail',
  TEXT_VACCINES_FORMULARY_VACCINE_NAME_MY_CHART_VACCINES_DETAIL = 'text-vaccines-formulary-vaccine-name-my-chart-vaccines-detail',
}
export { MyChartVaccinesDetailAliases };
